export const ADD = "booking/add";
export const DELETE = "booking/delete";
